import * as types from './mutation-types'

const matutaions = {
  [types.SET_COMICS] (state, comics) {
    state.comics = comics
  },
  [types.SET_CHAPTER] (state, chapter) {
    state.chapter = chapter
  },
  [types.SET_USER] (state, user) {
    state.user = user
  },
  [types.SET_PARAM] (state, param) {
    state.param = param
  },
  [types.SET_ISSHOW] (state, flag) {
    state.isShow = flag
  },
  [types.SET_CURRENTPAGE] (state, page) {
    state.currentPage = page
  },
  [types.SET_COUNT] (state, count) {
    state.count = count
  },
  [types.SET_POSTLIST] (state, postlist) {
    state.postlist = postlist
  }
}

export default matutaions



// WEBPACK FOOTER //
// ./src/store/mutations.js